var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-app container inner-app"},[_c('router-view',{staticClass:"inner-app-content"}),(_vm.isLoading)?_c('Loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }